import _taggedTemplateLiteral from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var _templateObject;

import styled from 'styled-components';
import { Button } from '@chakra-ui/button';
import { When } from '../utils/when';
import { ExpandMoreIcon } from '../icons/expand-more';
import { ExpandLessIcon } from '../icons/expand-less';
export function ExpandedButton(_ref) {
  var show = _ref.show,
      onClick = _ref.onClick;
  return /*#__PURE__*/_jsxs(ButtonExpanded, {
    "data-testid": "expanded-button",
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(When, {
      value: !show,
      children: /*#__PURE__*/_jsx(ExpandMoreIcon, {})
    }), /*#__PURE__*/_jsx(When, {
      value: show,
      children: /*#__PURE__*/_jsx(ExpandLessIcon, {})
    })]
  });
}
var ButtonExpanded = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 2em;\n  background: #fff;\n  border-radius: 50%;\n\n  &:hover {\n    background: #fff;\n  }\n\n  &:focus {\n    box-shadow: none;\n  }\n\n  @media screen and (max-width: 820px) {\n    padding: 1.5rem;\n  }\n"])));